const jobs = {
  reservations: 'Reservas',

  moreActions: {
    clearBlacklistedDrivers: {
      title: 'Limpar motoristas bloqueados?',
      body: 'Isto removerá quaisquer motoristas bloqueados das reservas selecionadas e das suas viagens associadas - as atribuições de motoristas existentes não são afetadas.',
      toastSuccess: 'Motoristas bloqueados removidos com sucesso.',
    },
  },

  btnCreate: 'Criar',
  btnRoute: 'Roteirizar',

  createHeaderTitle: 'Criar',
  updateHeaderTitle: 'Atualizar',

  import: {
    title: 'Importar Reservas',
  },

  toast: {
    error: {
      create: {
        badResponse: 'Ocorreu um erro ao criar a reserva',
      },
      edit: {
        badResponse: 'Ocorreu um erro ao atualizar a reserva',
      },
      find: {
        badResponse: 'Não foi possível encontrar serviços de transporte ',
      },
    },

    success: {
      create: {
        default: 'A reserva foi criada com sucesso',
      },

      update: {
        default: 'A reserva foi atualizada com sucesso',
      },
    },

    group: {
      success: 'A reserva foi agrupada com sucesso',
      failure: {
        privateOnly: 'Não foi possível agrupar essas reservas, uma vez que algumas delas estão definidas para ser apenas privado.',
        unknownError:
          'O agrupamento dessas reservas deparou com um problema inesperado. Por favor, tente novamente ou entre em contato com o nosso suporte.',
      },
    },

    ungroup: {
      success: 'A reserva foi desagrupada com sucesso',
    },

    blockWaitAndReturn: {
      success: 'A reserva de Esperar e Retornar foi desativada com sucesso',
    },

    unblockWaitAndReturn: {
      success: 'A reserva de Esperar e Retornar foi habilitada com sucesso',
    },
  },

  toolTip: {
    routingCancelJob: 'Pelo menos um trabalho não está no estado de novo',
    atLeastOneLockedJob: 'Pelo menos uma tarefa está bloqueada',
    noPermission: ' Sem permissão',
    atLeastOneStatusNotNew: 'Pelo menos um trabalho não está em novo status',
    dataSync: 'A sincronização de dados está em andamento',
  },

  create: {
    confirmButtonText: 'Enviar',
    successModal: {
      header: 'Sucesso',
      body: 'Reserva criada!',
    },

    errorModal: {
      header: 'Ocorreu um Erro',
      body: 'Não foi possível criar a reserva',
    },

    confirmationModal: {
      header: 'Confirmar Reserva',
      subtitle: 'Por favor, Leia o \'Roteiro\' Abaixo - Palavra por palavra - Não tenha pressa!!!',
      content:
        'Temos {{service}} reserva para {{seats}} pessoa\nEm {{date}} de {{from}} para {{to}}\n\nIsso está correto? Ótimo!\n\nO preço é de ${{price}}\nObrigado por ligar para o {{company}}',
      table: {
        headers: {
          details: 'Detalhes da Viagem',
          fare: 'tarifa',
        },

        fields: {
          details: {
            pickAdrs: 'Endereço de Recolher',
            dropAdrs: 'Endereço de Deixar',
            pickTime: 'Horário de Recolher',
            seats: 'Adultos',
          },
          fare: {
            service: 'Serviço',
          },
        },
      },
      bottomLine: 'Preço Total',
    },
    serviceTable: {
      columns: {
        name: 'Nome',
        maxPax: 'Máximo de passageiros',
      },
    },
    duplicateJobsModal: {
      body: 'Observe que existem outras reservas com exatamente os mesmos detalhes. Você quer continuar?',
      btnConfirm: 'Sim',
      btnClose: 'Não',
    },
  },

  payments: {
    table: {
      headers: {
        createdBy: 'Criado',
        email: 'E-mail do usuário originador',
        amount: 'Quantidade',
        type: 'Tipo',
        ccMasked: 'CC Mascarado',
        status: 'Status',
        refNum: 'Número de referência ',
      },
    },

    paymentsDetails: {
      title: 'Detalhes',

      status: {
        charged: 'Carregado:',
        pending: 'Pendente:',
        declined: 'Rejeitado:',
        variance: 'Variação:',
      },
    },

    addPaymentForm: {
      title: 'Adicione pagamento',

      fields: {
        amount: 'Quantidade',
        paymentType: 'Tipo de pagamento',
        cardNum: 'Número do crédito',
        cardExp: 'Expira',
        cvv: 'CVV',
        paymentOptions: {
          select: 'Selecione',
          credit: 'Crédito',
          directBill: 'Fatura direta',
          card: 'Cartões',
          expDate: 'Data de expiração',
        },
      },

      validations: {
        price: 'O preço deve ser maior que zero',
      },

      confirmPaymentBtn: 'Confirmar pagamento',
      modalSuccess: {
        header: 'sucesso!',
        body: 'Pagamento concluído com sucesso!',
      },

      modalError: {
        header: 'Ocorreu um erro!',
        body: 'Falha no pagamento. Por favor, tente novamente',
      },
    },
  },

  update: {
    title: 'Reserva #{{id}}',
    confirmButtonText: 'Enviar',

    successModal: {
      header: 'Sucesso',
      body: 'Reserva atualizada!',
    },

    errorModal: {
      header: 'Ocorreu um Erro',
      body: 'Não foi possível atualizar a reserva',
    },

    formTabs: {
      summary: 'Resumo',
      edit: 'Editar',
      payments: 'Pagamentos',
      notes: 'Observações',
      history: 'Histórico',
    },

    summary: {
      driver: 'Motorista',
      vehicle: 'Veículo',
      tripId: 'Identificação de viagem:',
      tripStatus: 'Status de Viagem',
      RPTime: 'Horário de Recolher solicitado',
      MPTime: 'Horário de Recolher solicitado',
      PETA: 'Estimativa de Horário de Recolher',
      PR: 'Recolher Relatado (motorista)',
      DR: 'Deixar Relatado (motorista)',
      empty: 'Não disponível',
      notAssigned: 'Não atribuído',
      notRouted: 'Não roteado',
      attributes: 'Atributos',
      noShow: 'No Show',
      supplier: 'Fornecedor',
    },
    jobNotSupported: 'Tipo de Reserva não suportado',
  },

  bulk: {
    select: 'Selecione',
    toasts: {
      createdSuccessfully: 'Reserva criada!',
    },

    errorModal: {
      header: 'Ocorreu um Erro',
      body: 'Não foi possível criar a reserva',
    },

    table: {
      direction: {
        to: 'Distribuir',
        from: 'Recolher',
        both: 'Recolher / Distribuir',
      },
    },

    direction: {
      label: 'Direção',
      to: 'Para',
      from: 'De',
      both: 'Ambos',
    },

    dateMode: {
      automated: 'Planejamento automático',
      manual: 'Selecção de tempo manual',
    },

    form: {
      information: {
        details: {
          header: 'Detalhes',
          fields: {
            shift: 'Turno',
            from: 'De',
            to: 'Para',
            fromDate: 'A partir da Data',
            toDate: 'Até à data',
            weekDays: 'Dias da Semana',
            fromHour: 'De hora em hora',
            toHour: 'Para a hora',
            requestPickup: 'Horário de Recolher solicitado',
            requestDropoff: 'Horário de Deixa solicitado',
            direction: 'Selecione a Direção',
            dateMode: 'Preferência de tempo',
          },
        },
        locations: {
          header: 'Locais',
          fields: {
            locations: 'Selecione o local',
          },
        },
        dateMode: {
          header: 'Preferência de tempo',
          label: 'Selecione a preferência de tempo',
        },
      },
    },
  },

  routeSummary: {
    reservations: 'Reservas',
    trips: 'Viagens',
    assigned: 'Atribuído',
    unassigned: 'Não atribuído',
    tripsAssigned: 'Viagens atribuídas',
    vehicles: 'Veículos',
    workingTime: 'Tempo de trabalho',
    drivingTime: 'Tempo de condução',
    miles: 'Milhas',
    routingProcessTime: 'Tempo de Roteirização',
  },

  headerButtons: {
    create: {
      new: 'Novo',
      quick: 'Rápido',
      bulk: 'Em massa',
      shuttle: 'Transporte',
      import: 'Importar',
      normal: 'Normal',
      schoolBooking: 'Reserva escolar',
      workplaceBooking: 'Reserva do local de trabalho',
    },

    import: 'Importar',

    route: {
      route: 'Roteirizar',
      routeAndAssign: 'Roteirizar e Atribuir',
    },

    moreActions: {
      button: 'Mais',
      options: {
        cancelModal: {
          title: 'Cancelar reservas',
          reasonInputPlaceholder: 'Por favor, insira um motivo para o cancelamento.',
          contentSingular: 'Você está prestes a cancelar 1 reserva.',
          contentPlural: 'Você está prestes a cancelar {{count}} reservas.',
          confirmButton: 'Confirmar',
          success: 'As reservas foram canceladas com sucesso',
        },
        deleteModal: {
          title: 'Excluir reservas',
          body: 'Você está prestes a excluir {{count}} reservas',
          success: 'As reservas foram excluídas com sucesso',
        },
        releaseRouting: {
          label: 'Lançar Rota',
        },
        manualRouteModal: {
          title: 'Manual Route',
          toolTip: {
            header: 'Drag and drop your selected bookings to arrange them in the desired trip order',
          },
          removeModal: {
            title: 'Remover Reservas',
            body: 'Você está prestes a remover 1 reserve',
            confirmButton: 'Confirmar',
          },
          durationExceeds: {
            title: 'Atenção - A duração da viagem excede 24 horas',
            body: 'A duração da viagem que você está prestes a planejar contém reservas com uma diferença de tempo que excede 24 horas. Tem certeza de que deseja continuar?"',
            confirmButton: 'Confirmar',
          },
        },
      },
    },
  },

  advancedRoutingModal: {
    all: 'Tudo',
    RouteBodyText: 'Você está prestes a roteirizar {{num}} reservas.',
    RouteAssignBodyText: 'Você está prestes a roteirizae e atribuir {{num}} reservas.',
    advancedSettings: 'Avançado',
    noJoin: 'Sem agrupar',
    joinOptions: {
      noJoin: 'Sem agrupar',
      tryJoin: 'Tentar agrupar',
      onlyJoin: 'Apenas agrupar',
    },
    clusterSettings: 'Configuração de Cluster',
    assignSettings: 'Configurações de atribuição de motorista',
    routeJobs: 'Roteirizar Reservas',
    routeAssignJobs: 'Roteirizar e Atribuir Reservas',
    advancedRoutingSettings: 'Configurações Avançadas de Roteirizaração',
    mainParameters: 'Configuração de Roteirização',
    ratio: 'Proporção',
    ratioInfo:
      '1.5 significa que a duração de uma pessoa sentada no veículo não irá exceder 150% do tempo que ela deveria ter gasto conduzindo sozinho.',
    pax: 'Máximo de passageiros',
    paxInfo: 'Número máximo de lugares por viagem',
    maxDuration: 'Duração máxima',
    maxDurationInfo: 'Duração máxima de uma viagem',
    maxStops: 'Máximo de paradas',
    maxStopsInfo: 'Máximo de paradas em uma viagem',
    pickSeconds: 'Horário de Embarque',
    pickSecondsInfo:
      'Tempo de embarque calculado do trabalho. a duração total da viagem será estendida. Os horários serão adicionados à matriz "espera" para esta parada.',
    dropSeconds: 'Horário de Deixa',
    dropSecondsInfo:
      'Tempo de entrega calculado do trabalho. a duração total da viagem será estendida. Os horários serão adicionados à matriz "espera" para esta parada.',
    pickGapAfter: 'Atraso máximo',
    pickGapAfterInfo: 'O horário de recolha de um trabalho não será superior a 30 minutos do horário de recolha de outro trabalho.',
    pickGapBefore: 'Antecipação máxima',
    pickGapBeforeInfo: 'O horário de recolha de um trabalho não precederá o horário de recolha de outro trabalho em mais de 30 minutos.',
    airKMPH: 'Aéreo KMPH',
    airKMPHInfo: 'Entre em contato com o suporte',
    allowLate: 'Permitir atraso',
    allowLateInfo: 'Entre em contato com o suporte',
    maxPrice: 'Preço Máximo',
    maxPriceInfo: 'Entre em contato com o suporte',
    maxTrips: 'Máximo de viagens',
    maxTripsInfo: 'Suporte ao máximo de viagens',
    shiftMaxMinutes: 'Máximo de Minutos do Turno',
    shiftMaxMinutesInfo: 'Entre em contato com o suporte',

    routeTemplates: 'Templates de Roteirização',
    assignTemplates: 'Atribuir Templates',

    form: {
      validation: {
        mustBeHigher: 'Deve ser {{val}} ou superior',
      },
    },
  },

  clusters: {
    clusterRadius: 'Diâmetro do Cluster',
    snapTo: 'Modo',
    none: 'Nenhum',
    both: 'Ambos',
    to: 'Para',
    from: 'De',
    address: 'Endereço',
    bus: 'Ponto de Onibus',
  },

  forms: {
    header: {
      createNewRservationTitle: 'Nova reserva',
      updateReservationTitle: 'Reserva',

      createNormalRservation: {
        subTitle: 'Normal',
      },

      createQuickRservation: {
        subTitle: 'Rápido',
      },

      createShuttleRservation: {
        subTitle: 'Transporte',
      },
    },

    roundTrip: 'Viagem de ida e volta',
    oneWay: 'Só um sentido',
    information: {
      details: {
        header: 'Detalhes do perfil',
        fields: {
          site: 'Local',
          profile: 'Perfil',
        },
      },
      jobDetails: {
        flightTypes: {
          international: 'Internacional',
          domestic: 'Doméstico',
          customerRequest: 'solicitação do cliente',
        },
        fareBreakdown: 'Repartição de tarifa',
      },
      linkedPassengers: {
        header: 'Passageiros Conectados',
        searchPlaceholder: 'Buscar',
      },
      reservationDetails: {
        header: 'Detalhes da reserva',
        fields: {
          from: 'De',
          to: 'Para',
          terminal: 'Terminal',
          seats: 'Assentos',
          checkedBags: 'Malas despachadas',
          switchADA: 'ADA',
          wheelchair: 'Cadeira de rodas',
          adults: 'Adultos',
          infants: 'Bebês',
          carryon: 'Carrinho',
        },
        clearBtn: 'Limpar',
      },
      flightDetails: {
        header: 'Informações do Voo',
        flightAirline: 'Companhia Aérea',
        flightNumber: 'Número do Voo',
        scheduledFlightTime: 'Horário Programado do Voo',
        actualFlightTime: 'Horário Real do Voo',
        flightStatus: 'Status do Voo',
      },
      caregiverInformation: {
        header: 'Informações para Cuidadores',
        fields: {
          firstName: 'Nome',
          lastName: 'Sobrenome',
          address: 'Endereço',
          phone: 'Telefone',
        },
      },
      serviceAndTime: {
        header: 'Serviço e Horário',
        fields: {
          scheduleBy: 'Planejamento por',
          dateTime: 'Data e Hora',
          service: 'Serviço',
          switchRecurring: 'Recorrente',
          attributes: 'Atributos',
          repeatEvery: 'Repetir a Cada',
          ends: 'Termina em',
          never: 'Nunca',
          on: 'Em',
          after: 'Depois',
          occurrences: 'Ocorrências',
        },
        buttons: {
          now: 'Agora',
        },
      },
      personalInfo: {
        header: 'Informações pessoais',
        fields: {
          email: 'E-mail',
          fullName: 'Nome completo',
          firstName: 'Nome',
          lastName: 'Sobrenome',
          phone: 'Telefone',
          address: 'Endereço',
          specialIdentifier: 'Identificador Especial',
        },
      },
      billingInfo: {
        sameAsPersonalInformation: 'O mesmo que informação pessoal',
        header: 'Informações de faturamento',
        fields: {
          country: 'País',
          state: 'Estado',
          zip: 'CEP',
        },
      },
      payments: {
        header: 'Pagamentos',
        fields: {
          price: 'Preço',
          paymentSelect: {
            header: 'Tipo de pagamento',
            options: {
              credit: 'Crédito',
              directBill: 'Fatura direta',
            },
          },
          cardNum: 'Número do crédito',
          cardExp: 'Expira',
          cvv: 'CVV',
        },
      },
      additionalFields: {
        header: 'Campos adicionais',
        fields: {
          driver: 'Motorista',
          car: 'Carro',
          waitMinutes: 'Minutos de espera',
        },
      },
      notes: {
        header: 'Observações',
      },
      profile: {
        header: 'Perfil',
        label: 'Selecionar perfil',
      },
      passengers: {
        header: 'Informações pessoais',
        label: 'Selecionar passageiros',
      },
      attributes: {
        header: 'Atributos',
        label: 'Selecionar Atributos',
      },
      supplier: {
        header: 'Fornecedor',
      },
    },
    validations: {
      unit: {
        required: 'O perfil é obrigatório',
      },
      amount: {
        required: 'A quantidade é obrigatória',
      },
      from: {
        required: 'De é obrigatório',
      },
      direction: {
        required: 'Direção é obrigatória',
      },
      to: {
        required: 'Para é obrigatório',
      },
      type: {
        required: 'Obrigatório',
      },
      email: {
        message: 'Insira um e-mail válido',
        required: 'E-mail é obrigatório',
      },
      firstName: {
        conditions: {
          min: 'O Nome deve ter no mínimo 2 caracteres',
          max: 'O Nome deve ter no máximo 30 caracteres',
        },
        required: 'Nome é obrigatório',
      },
      lastName: {
        conditions: {
          min: 'O Sobrenome deve ter no mínimo 2 caracteres',
          max: 'O sobrenome deve ter no máximo 30 caracteres',
        },
        required: 'Sobrenome é obrigatório',
      },
      phone: {
        message: 'O número de telefone não é válido',
        required: 'O número de telefone é obrigatório',
      },
      price: {
        message: 'O preço deve ser um número',
        required: 'O preço é obrigatório',
      },
      flightTerminal: {
        required: 'Terminal de voo é necessário',
      },
      adults: {
        required: 'Adultos é necessário',
      },
      seats: {
        required: 'Lugares é necessário',
      },
      infants: {
        required: 'Infantil é necessário',
      },
      carryon: {
        required: 'Carrinho é necessário',
      },
      paymentType: {
        required: 'O Tipo de pagamento é obrigatório',
      },
      cardNum: {
        required: 'O Número do cartão é obrigatório',
      },
      cardExp: {
        required: 'É obrigatória a data de expiração do cartão',
      },
      cvv: {
        required: 'O CVV é necessário',
      },
      profile: {
        required: 'O perfil é obrigatório',
      },
      fare: {
        required: 'A tarifa é obrigatória',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
        delete: 'Excluir',
      },
    },
  },

  table: {
    footer: {
      totalSeats: 'Total de Assentos: {{seats}}',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
      route: 'Roteirizar',
      cancel: 'Cancelar',
      routeAndAssign: 'Roteirizar e Atribuir',
      group: 'Agrupar',
      ungroup: 'Desagrupar',
      blockWaitAndReturn: 'Desativar Esperar e Voltar',
      unblockWaitAndReturn: 'Habilitar Esperar e Voltar',
      clearBlacklistedDrivers: 'Limpar motoristas bloqueados',
      releaseRouting: 'Lançar Rota',
      sendToBid: 'Enviar para licitação',
      estimateWillCalls: 'Estimar Will Calls',
      tooltips: {
        estimateWillCallsDisabled: 'Pelo menos uma tarefa não está com o status “novo”'
      }
    },
    cells: {
      car: {
        none: 'Nenhum Veículo',
      },
      driver: {
        none: 'Sem motorista',
      },
      supplier: {
        none: 'Sem Fornecedores',
      },
    },
    filters: {
      status: 'Status',
      profile: 'Perfis',
      supplier: 'Fornecedores',
      attributes: 'Atributos',
      flightNumber: 'Número do Voo',
      airline: 'Companhia Aérea',
      flightStatus: 'Status do Voo',
      drivers: 'Motoristas',
      vehicles: 'Veículos',
      from: 'De',
      to: 'Para',
      locations: 'Localizações',
      airportLocations: 'Localizações de Aeroporto',
      areas: 'Zonas',
    },
    headers: {
      externalID: 'Identificador Externo',
      flightInfo: 'Informações do Voo',
      id: 'Identificação',
      io: 'E&S',
      returnTrip: 'Viagem de ida e volta',
      legA: 'Percurso A',
      legB: 'Percurso B',
      seats: 'Assentos',
      driver: 'Motorista',
      vehicle: 'veículo',
      from: 'De',
      to: 'Para',
      supplier: 'Fornecedor',
      statusAndId: 'Identificação',
      passenger: 'Passageiro',
      indicators: 'Indicadores',
      attributes: 'Atributos',
      extendUntilDate: 'Esperar até',
      date: 'Date',
      phone: 'Phone',
      flightNumber: 'Número do Voo',
      email: 'Email',
      service: 'Service',
      airline: 'Companhia Aérea',
      scheduledFlightTime: 'Horário Programado do Voo',
      actualFlightTime: 'Horário Real do Voo',
      flightStatus: 'Status do Voo',
      price: 'Price',
      profile: 'Profile',
      areas: 'Zonas',
      distance: 'Distância',
      duration: 'Duração',
    },
    statuses: {
      new: 'Novo',
      onHold: 'Em espera',
      canceled: 'Cancelado',
      routing: 'Roteirizando',
      routed: 'Roteirizado',
      picked: 'Recolhido',
      dropped: 'Deixado',
      noshow: 'No Show',
    },
    labels: {
      grouped: 'Agrupado',
      waitAndReturn: 'Esperar E Voltar',
      roundTrip: 'Ida e Volta',
      arrivalTime: {
        label: 'Hora de chegada',
        tooltip: 'Hora de chegada',
      },
    },
  },

  assignVehiclesDrivers: {
    routeSummaryModal: {
      header: 'Resumo da Linha',
    },
  },

  checkRouteStatus: {
    routeSummaryModal: {
      header: 'Resumo da Linha',
    },
  },
  shuttleReservation: {
    create: {
      confirmButtonText: 'Reservar',
    },

    form: {
      information: {
        recurring: {
          header: 'Recorrente',
        },
        personalInformation: {
          header: 'Detalhes pessoais',
          fields: {
            firstName: 'Nome',
            lastName: 'Sobrenome',
            email: 'E-mail',
            phone: 'Telefone',
          },
        },
        paymentOption: {
          header: 'Opções de pagamento',
          fields: {
            paymentType: 'Tipo de pagamento',
            cardNum: 'Número do cartão',
            cardExp: 'Expira',
            cvv: 'CVV',
            rate: 'Taxa',
            amount: 'Quantidade',
            fare: 'tarifa',
          },
          paymentTypes: {
            free: 'Livre',
            opuscard: 'Cartão OPUS',
            cashonboard: 'Dinheiro a Bordo',
            creditcard: 'Cartão de crédito',
            correspondance: 'Correspondência',
          },
          rateTypes: {
            ordinary: 'Valor em Numerário',
            reduced: 'Reduzido',
          },
        },
        bookingDetails: {
          header: 'Detalhes da reserva',
          fields: {
            supplier: 'Fornecedor',
            date: 'Data',
            hour: 'Hora',
            area: 'Zona',
            direction: 'Direção',
            operationHours: 'Horário de funcionamento',
            line: 'Transporte',
            pickup: 'Recolhimento',
            dropoff: 'Deixa',
            seats: 'Assentos',
          },
        },
      },
      validations: {
        drivers: {
          required: 'Motoristas é necessário',
        },
        area: {
          required: 'Zona é obrigatório',
        },
        direction: {
          required: 'Direção é obrigatória',
        },
        unit: {
          required: 'Requer-se a unidade',
        },
        supplier: {
          required: 'Requer-se fornecedor',
        },
        driver: {
          required: 'Requer-se motorista',
        },
        start: {
          required: 'A Data de Início é obrigatória',
        },
        end: {
          required: 'A Data de Término é obrigatória',
        },
        firstName: {
          required: 'Nome é obrigatório',
        },
        lastName: {
          required: 'Sobrenome é obrigatório',
        },
        email: {
          required: 'E-mail é obrigatório',
        },
        phone: {
          required: 'O telefone é obrigatório',
        },
        date: {
          required: 'A data é obrigatória',
        },
        line: {
          required: 'É necessário Shuttle',
        },
        hour: {
          required: 'É requerido uma Hora',
        },
        from: {
          required: 'De é obrigatório',
        },
        fromLat: {
          required: 'Latitude inicial é obrigatório',
        },
        fromLon: {
          required: 'Longitude inicial é obrigatório',
        },
        to: {
          required: 'Para é obrigatório',
        },
        toLat: {
          required: 'Latitude final é obrigatório',
        },
        toLon: {
          required: 'Latitude final é obrigatório',
        },
        seats: {
          required: 'Lugares é necessário',
          conditions: {
            min: 'Os lugares deveriam ser maiores que {{min}}',
          },
        },
        paymentOptions: {
          required: 'As Opções de pagamento são obrigatórias',
          paymentType: {
            required: 'O Tipo de pagamento é obrigatório',
          },
          data: {
            required: 'Os dados de pagamento são obrigatórios',
            opusCard: {
              minLength: 'Deve ter exatos 12 caracteres',
            },
          },
        },
      },
    },

    toasts: {
      notFound: 'Shuttle não encontrado para este dia!',
    },
  },
  duplicatedCreationModal: {
    header: 'Reserva Duplicada: Continuar?',
    body: 'Existem outras reservas com detalhes idênticos. Você deseja continuar com a criação da reserva?',
  },

  duplicatedUpdatingModal: {
    header: 'Reserva Duplicada: Continuar?',
    body: 'Existem outras reservas com detalhes idênticos. Deseja continuar com a atualização da reserva?',
  },

  modals: {
    groupModal: {
      header: 'Agrupar Reservas',
      body: 'Você está prestes a agrupar {{count}} reservas',
      btnConfirm: 'Confirmar',
    },
    confirmGroupModal: {
      header: 'Agrupar Reservas',
      body: 'Uma das reservas já foi agrupada. Deseja continuar e reagrupae?',
    },
    unGroupModal: {
      header: 'Desagrupar reservas',
      body: 'Você está prestes a desagrupar {{count}} reservas',
      btnConfirm: 'Confirmar',
    },
    blockedGroupModal: {
      header: 'Agrupar/desagrupar reservas',
      body: 'A ação Agrupar/Desagrupar só é permitida em reservas com o status "Novo"',
      btnConfirm: 'Fechar',
    },
  },
};

export default jobs;
